
import sup3 from "../../assets/surgical-products/sup-3.png";
import sup4 from "../../assets/surgical-products/sup-4.png";
import sup5 from "../../assets/surgical-products/sup-5.png";
import sup2 from "../../assets/surgical-products/sup-2.png";
import sup6 from "../../assets/surgical-products/sup-6.png";
import sup7 from "../../assets/surgical-products/sup-7.png";
import sup8 from "../../assets/surgical-products/sup-8.png";
import sup9 from "../../assets/surgical-products/sup-9.png";
import sup10 from "../../assets/surgical-products/sup-10.png";
import sup11 from "../../assets/surgical-products/sup-11.png";
import sup12 from "../../assets/surgical-products/sup-12.png";
import sup1 from "../../assets/surgical-products/sup-1.png";
import sup13 from "../../assets/surgical-products/sup-13.png";
import sup14 from "../../assets/surgical-products/sup-14.png";
import sup15 from "../../assets/surgical-products/sup-15.png";
import sup16 from "../../assets/surgical-products/sup-16.png";
import sup17 from "../../assets/surgical-products/sup-17.png";
import sup18 from "../../assets/surgical-products/sup-18.png";
import sup19 from "../../assets/surgical-products/sup-19.png";
import sup20 from "../../assets/surgical-products/sup-20.png";
import sup21 from "../../assets/surgical-products/sup-21.png";
import sup22 from "../../assets/surgical-products/sup-22.png";

const dataSurgicalProducts = [
    {
        image: sup3,
        productHeader: "INFUSION SET",
        points: [
            " Clear, Transparent & Flexible Moulded Chamber (Vented or Non-Vented).",
            " Super smooth kink resistant tube. Very efficient roller controller for accurate flow rate.",
            " Self-sealing Plain Latex / Bulb Latex for easy flushing. Needle size G: 21.",
            "Available with Y-Connector & Luer-Lock.",
            "EO Sterile Individual Packed.",
            "Available in HM-Poly Pouch/Ribbon Poly Pouch/Paper Pouch/Blister Pack"
        ],
    },
    {
        image: sup4,
        productHeader: "BLOOD ADMINISTRATION SET",
        points: [
            "Clear, Transparent & Flexible Single/Double drip Chamber Super Smooth kink resistant tube.",
            " Very efficient roller controller for accurate flow rate.",
            "Self-sealing Plain Latex / Bulb Latex for easy flushing",
            "Needle size G: 18 EO Sterile.",
            "Individual Packed.",
            "Available in HM-Poly Pouch/Ribbon Poly Pouch/Paper Pouch/Blister Pack."

        ],
    },  
    {
        image: sup5,
        productHeader: "MEASURED VOLUME SET (PEDIATRIC SET/BURETTE SET)",
        points: [
            " Flexible, Transparent & soft cylindrical measured volume chamber of 110ml / 150 ml",
            "Efficient roller controller for better flow control.",
            "Special Beveled strong spike for smooth penetration.",
            "Specially designed floating auto shut off valve acts as floating indicator and automatically shut off the drain path when the chamber gets empty to prevent air trapping in the fluid line.",
            " Available with or without ‘Y’ connection.",
            " Soft and Kink Resistant tube.",
            "Bulb Latex or Tube latex for easy flushing.",
            "Separate plug for extra medication and continuous change over",
            "Needle size G: 23",
            " EO Sterile. Individual Packed.",
            "Available in HM-Poly Pouch/Ribbon Poly Pouch."
        ],
    },
    {
        image: sup2,
        productHeader: "URINE COLLECTION BAG",
        points: [
            "Manufactured from soft clinical grade PVC sheet. Super smooth kink resistant tube",
            "Modification with direct bed attachment & specially designed molding hanger/thread system for carrying & hanging arrangement.",
            " Efficient non return valve prevents the back flow of bacteria migration. Bottom/Upper outlet allows easy emptying. ",
            "Provided with air vent.",
            "Capacity 2000 ml Approx.",
            " EQ Sterile Available in HM Poly Pouch/Ribbon Poly Pouch"
        ],
    },
    {
        image: sup6,
        productHeader: "NELATON CATHETER",
        points: [
            "Manufactured from non-toxic PVC medical grade. A traumatic, soft rounded, closed tip with two lateral eyes for efficient drainage.",
"Color coded plain connector for easy identification of size. Universal funnel shape connector for easy connection to urine bag. ",
"X-Ray opaque line provided throughout the length of catheter. EO Sterile Available in Ribbon Poly Pouch/ Paper Pouch."
        ],
    },
    {
        image: sup7,
        productHeader: "URINE COLLECTION BAGS WITH MEASURED VOLUME SET",
        points: [
            "Manufactured from Medical grade material.",
            "Manufactured from Medical grade material urine output during examination of the patient.",
            "Urine Bag is manufactured from extra strong sheeting to withstand during the long period.",
            "Urine bag attached directly with measured volume meter ensures auto over flow and convenience to empty the measured volume meter in the bag.",
            "Bag Capacity: 2000 ml. Approx.",
            " Chamber Capacity: 250 ml. Approx.",
            "Provided with “T” Type bottom Outlet is provided for easy & Quick Emptying of Urine Bags. EO Sterile",
            "Available in HM Poly Pouch/Ribbon Poly Pouch."
        ],
    },
    {
        image: sup8,
        productHeader: "MALE EXTERNAL CATHETER",
        points: [
            "Manufactured from pure latex for soft and gentle feel.",
            "Male catheter is specially designed for urine incontinence for day and night use in male patient. Provided with self-adhesive coated strip for proper fixing on to the penis.",
            "Proximal end is designed for easy connection to urine bag, making it simple to use.",
            "EO Sterile Available in Paper Pouch/Ribbon Poly Pouch."
        ],
    },
    {
        image: sup9,
        productHeader: " ANAESTHESIA BREATHING SYSTEMS [BRAIN CIRCUIT]",
        points: [
            " 22mm Adult Corrugated, flexible and light weight tubing.",
            "Manually adjustable APL valve",
            "23mm Boyles Connector",
"3 meterextra length Oxygen tubing 22M/15F-15M Fixed Elbow",
"2 Litre Reservior Bag"
        ],
    },
    {
        image: sup10,
        productHeader: "BREATHING FILTER",
        points: [
            "Used in respiratory support equipment such as life support and human ventilation machine, fitted in the airway between equipment and patient. The removal of bacteria from the air breathed in the hospital environment is critical in the protection of the patients, other hospital personnel and breathing support equipment.",
            "Filters utilize hydrophobic membrane & synthetic media that provide barrier & electrostatic",
            " filtration with bacterial & vital removal efficiency higher than 99.99% accomplished with extremely low resistance to airflow. The HMW Keeps moisture retention and warming of inhaled air filter design in different sizes with CO2 monitoring port, facilitate use one wider range of patients. Products features . Clear housing, Low flow resistance High filtration efficiency, High heat & humidity level, CO2",
            "Mentoring level, Port Sterile package. Size: ADULT/PAEDIATRIC",
            "Sterile/Disposable/individual Packed"
        ],
    },
    {
        image: sup11,
        productHeader: "THREE BALL SPIROMETER (BREATHING EXCISOR)",
        points: [
            "Three color-coded balls in each chamber rise proportionately to the inspiration exerted by the user provide a visual incentive for the patient"
        ],
    },
    {
        image: sup12,
        productHeader: "CATHETER MOUNT",
        points: [
            "Catheter Mount connects patient ET to breathing circuit. This minimizes the jerk of breathing to ET or TT reducing trauma to trachea. The double swivel makes no dragging on breathing circuit & ET or TT.",
            "Light weight, Double swivel rotates 360° on both axis, Minimum compliance, Low dead.:15F-15M Double swivel elbow mount with 7.6 mm suction port and non-popping cap22F-15M Straight Connector.",
            "15mm-17.5 cm Corrugated transparent flexible tubing.",
            "Be made of medical-grade PVC, 100% latex free . EO Sterile",
            "Available in HM Poly Pack/Ribbon Poly Pack."
        ],
    },
    {
        image: sup1,
        productHeader: "OXYGEN MASK",
        points: [
            "Made of clear, non-toxic PVC",
            "Mouldedface mask has adjustable elastic strap and integrated nose clip for proper positioning of mask on the mouth and nasal area.",
            "Specially designed for convenient oxygen therapy.",
            "Provided with long star lumen tube to ensure continuous flow of Oxygen.",
            "The tube has funneled shaped connector at the proximal end to facilitate simple & safe connection with the oxygen Tube",
            "EO Sterile.",
            "Available in HM Poly Pack/Ribbon Poly Pack."
        ],
    },
    {
        image: sup13,
        productHeader: "HIGH CONCENTRATION OXYGEN MASK",
        points: [
            " With tubing is intended to supply oxygen or other gases to an Individual for oxygen therapy, and the reservoir bag is able to avoid rebreathing.",
            "Transparent (green or white) plastic masks also leave the face visible, allowing care providers to better ascertain patients conditions.",
            "Comes with 1L Reservoir Bag",
            "Be made of medical-grade PVC, 100% latex free.",
            "Smooth and feathered edge of face mask for patient comfort and reducing irritation points",
            "Tube Length: As per requirements",
            " EO Sterile/Disposable/ individual Packed",
            "Size: ADULT/PAEDIATRIC"
        ],
    },
    {
        image: sup14,
        productHeader: "NEBULIZER KIT",
        points: [
            "Designed to be used with any standard Nebulizer kit.",
            "Made from a soft clear plastic and are anatomically formed for comfort.",
            "Latex-Free.",
            " It has an Elastic Strap for added comfort",
            "Each Mask is individually sealed and wrapped for safety",
            "The Nebulizer Kit just plugs into the standard fitting located at the bottom of the Mask",
            "Masks are designed to deliver more medication directly to the patient due to the direct flow design. Masks are contoured to fit the face of adult and are very comfortable to wear.",
            "Tube Length: 210 cm",
            "EO Sterile",
            "Available in HM Pop Pack/Ribbon Holy Package"
        ],
    },
     {
        image: sup15,
        productHeader: "SUCTION CATHETER",
        points: [
            "Manufactured from non-toxic non-irritant medical grade PVC. Suction catheters are suitable for removal of secretion from mouth oropharynx and bronchial tubes(trachea)",
            "A traumatic, soft & rounded open tip with one lateral eye. Provided with T type vaccum control valve with thumb control for pro permaneuvering.",
            " Frozen surface tubing for smooth intubation",
            "Color coded for easy identification.",
            " EO Sterile",
            " Available in HM Poly Pack/Ribbon Poly Pack",
            "Available in FG8-FG 29 sizes",
        ],
    },
     {
        image: sup16,
        productHeader: "TWIN BORE NASAL OXYGEN SET",
        points: [
            "Manufactured from Soft, non-toxic PVC thus non irritating even in long term use. Soft twin prong nasal tips to ensure equal volume of oxygen to both air passages. Smoothly finished &adjustable nasal tips for num patient’s comfort",
            "Star lumen tube ensures the supply of oxygen even if tube is accidently kinked.",
            "Soft funnel shaped connector facilitates easy connection to oxygen source.",
            "EO Sterile Available in HM Poly Pack/Ribbon Poly Pack."
        ],
    },
     {
        image: sup17,
        productHeader: "ENDOTRACHEAL TUBE",
        points: [
            " Non-toxic, medical grade PVC material, Clear, soft and smooth. High volume, low pressure cuff, maintains seal throughout ventilator cycle ",
            "X-ray detective line available",
            "Thermosensitive PVC allows the tube to soften at body temperature to conform to airway anatomy Clear PVC tube with visible markings for easy observation",
            "A Murphy Eye smoothly formed to allows ventilation in the event at obstruction of the end of the tube during intubation",
            " A full range of standard sized to meet most of your requirements. Sterile/Disposable/ Individual Packed"
        ],
    },
     {
        image: sup18,
        productHeader: " T-RECOVERY KIT",
        points: [
            "T-Piece Kit designed for use in recovery for the delivery of Oxygen via the patients 15mm ET connection or Laryngeal mask",
            "7.6mm Port for Suction with non-popping cap",
            " The kit comprises T-Piece with port, 22mm-15cm reservoir flex tube and Oxygen Stem with Cap"
        ],
    },
     {
        image: sup19,
        productHeader: "GUEDAL AIRWAYS",
        points: [
            "Manufactured from EVA to achieve extra soft surface finish Designed to maintain an unobstructed",
            "Oro-Pharyngeal airway during or following general anesthesia and in patients who are unconscious for other reasons",
            "A traumatic soft-rounded edges",
            "Stepless airway path for easy cleaning Bite blocks are color coded for easy identification."
        ],
    },
     {
        image: sup20,
        productHeader: "RESUSCITATOR BAGS",
        points: [
            "The AmbuBag consists of a flexible air chamber, attached to a face mask via a shutter valve. When the air chamber or “bag” is squeezed, the device forces air through into the patient’s lungs. when the bag is released, it self-inflates, drawing in ambient air or a low pressure oxygen flow supplied from a regulated cylinder, whilst the patient’s lungs deflate to the air through the one way valve",
        ],
    },
     {
        image: sup21,
        productHeader: "WOUND DRESSINGS & SWABS",
        points: [
            "CHLORHEXIDINE GAUZE DRESSING(ANTISEPTIC TULLE DRESSING)",
            "Chlorhexidine acts as a soothing agent. The antibiotic/antiseptic in it helps in the healing process. Interlocking gauze yam threads, minimize when dressing is cut to shape.",
            " Does not stick to the wound and does not disturb the dressing process",
            "Due to special type of butter paper loss of medicine after removal of butter paper is minimum",
            "Sterilized by GAMMA radiation EO Sterile",
            "Available in HM Poly Pouch/Ribbon Poly Pouch"
        ],
    },
     {
        image: sup22,
        productHeader: "PARAFFIN GAUZE DRESSING",
        points: [
            "Paraffin acts as a soothing agent. The antibiotic/antiseptic in it helps in the healing process Interlocking gauze yarn threads, minimize when dressing is cut to shape Does not stick to the wound and does not disturb the dressing process Due to special type of butter paper loss of medicine after removal of butter paper is minimum",
            "Sterilized by GAMMA radiation"
        ],
    },

];

export const SurgicalProductsConstant = {
    dataSurgicalProducts,
};